import {useMutation} from '@tanstack/react-query';
import {useTranslation} from 'react-i18next';
import {searchInvestorsAsComboboxValues} from '@/components/new-document-creation/dialog/search-investors-as-combobox-values';
import {Toaster} from '@/initializers/toaster';
import {analyticsHandler} from '@/services/analytics/analytics-handler';
import {AdvisorCodes} from './advisor-code-step';

type Options = {
  analytics_search_location: string;
};

export const useSearchInvestorsMutation = (advisorCodes: AdvisorCodes, {analytics_search_location}: Options) => {
  const {t} = useTranslation();

  return useMutation({
    mutationKey: ['search-investors-as-combobox-values', advisorCodes],
    mutationFn: searchInvestorsAsComboboxValues(advisorCodes),
    onSuccess: data => {
      analyticsHandler.webSearch({
        search_location: analytics_search_location,
        search_results_count: data.length,
      });
    },
    onError: () => {
      Toaster.error(t('components.combobox.fetch-error-default-message'));
    },
    retry: false,
  });
};
